module.exports = __webpack_public_path__ + "img/violet_134.a0dd719f.png";